import { AbstractWidgetSettings } from "../../components/ConfigurationPage/widgetsettings/AbstractWidgetSettings";

export class RutonyChatSettings extends AbstractWidgetSettings {
  constructor() {
    super({ sections: [] });
  }
}
